export default __webpack_public_path__ + "static/media/martinique.832f76ac.svg";